import { generateRequest } from './index';
import { toQueryString } from '../../lib/utils/querystring';
import { REVIEWS_PAGE_SIZE } from '../constants/reviewRatings';

export const Action = {
  Reviews: {
    ReviewsPending: 'Reviews_PENDING',
    ReviewsCompleted: 'Reviews_FULFILLED',
    ReviewsFailed: 'Reviews_FAILED',
    ReviewSettingsPending: 'ReviewSettings_PENDING',
    ReviewSettingsCompleted: 'ReviewSettings_FULFILLED',
    ReviewSettingsFailed: 'ReviewSettings_FAILED',
    SubmitReviewPending: 'SubmitReview_PENDING',
    SubmitReviewCompleted: 'SubmitReview_FULFILLED',
    SubmitReviewFailed: 'SubmitReview_FAILED',
    UpdateReviewPending: 'UpdateReviewPending',
    UpdateReviewCompleted: 'UpdateReviewCompleted',
    UpdateReviewFailed: 'UpdateReviewFailed',
  },
};

export const fetchReviewSettings = stationId => generateRequest({
  credentials: 'same-origin',
  endpoint: `/assets-v2/api/reviews/settings?stationId=${stationId}`,
  types: [
    Action.Reviews.ReviewSettingsPending,
    Action.Reviews.ReviewSettingsCompleted,
    Action.Reviews.ReviewSettingsFailed,
  ].map(actionType => ({ type: actionType, meta: { stationId } })),
});

export const fetchReviewsByStationId = (stationId, page = 1, limit = REVIEWS_PAGE_SIZE) => generateRequest({
  endpoint: `/assets-v2/api/stations/${stationId}/reviews?${toQueryString({ page, limit })}`,
  types: [
    { type: Action.Reviews.ReviewsPending, meta: { stationId, limit } },
    { type: Action.Reviews.ReviewsCompleted, meta: { stationId } },
    { type: Action.Reviews.ReviewsFailed, meta: { stationId } },
  ],
});

export const submitReview = body => generateRequest({
  method: 'POST',
  credentials: 'same-origin',
  endpoint: '/assets-v2/api/reviews',
  body,
  types: [
    Action.Reviews.SubmitReviewPending,
    Action.Reviews.SubmitReviewCompleted,
    Action.Reviews.SubmitReviewFailed,
  ],
});

export const updateReview = ({ id, ...body }) => generateRequest({
  method: 'PATCH',
  credentials: 'same-origin',
  endpoint: `/assets-v2/api/reviews/${id}`,
  body,
  types: [
    Action.Reviews.UpdateReviewPending,
    Action.Reviews.UpdateReviewCompleted,
    Action.Reviews.UpdateReviewFailed,
  ].map(actionType => ({
    type: actionType,
    meta: {
      id,
      hasAgreed: body.hasAgreed,
      hasFlagged: body.hasFlagged,
    },
  })),
});
